import { Moment } from 'moment';

export type FormStep = {
	icon: JSX.Element;
	title: string;
	component: JSX.Element;
};

export interface GeneralInformation {
	file_id?: string;
	company_id: string;
	organization_id: string;
	sector_id: string;
	line_id: string;
	workstation_id: string;
	activity_id: string;
	evaluator_id: string;
	collect_date: Moment | undefined;
	workday_duration: number;
	activity_duration: number;
	company_name?: string;
	organization_name?: string;
	sector_name?: string;
	line_name?: string;
	workstation_name?: string;
	activity_name?: string;
	evaluator_name?: string;
	file_name?: string;
	transporting_cargo_in_pairs?: boolean;
}

export interface Frequency {
	frequency: number | null;
	weight: number | null;
	inclined_weight?: boolean;
	transporting_cargo_in_pairs?: boolean;
	cargo_handling_condition?: string;
	frequency_score?: number | null;
	effective_weight?: number | null;
	man_weight_score?: number | null;
	woman_weight_score?: number | null;
	cargo_handling_condition_score?: number | null;
	man_score?: number | null;
	woman_score?: number | null;
}

export interface Posture {
	body_posture: string | undefined;
	posture_additional_factor_twist: string | undefined;
	posture_additional_factor_load_center: string | undefined;
	posture_additional_factor_arms: string | undefined;
	posture_additional_factor_hands: string | undefined;
	body_posture_score?: number | null;
	additional_factors_score?: number | null;
	man_score?: number | null;
	woman_score?: number | null;
}

export interface WorkCondition {
	work_condition_hands_position?: string;
	work_condition_transfer?: string;
	work_condition_spatial_condition?: string;
	work_condition_adverse?: string;
	work_condition_clothes?: string;
	work_condition_hold_load?: string;
	work_condition_score?: number | null;
	man_score?: number | null;
	woman_score?: number | null;
}

export interface WorkOrganization {
	work_organization?: string;
	work_organization_score?: number | null;
	man_score?: number | null;
	woman_score?: number | null;
}

export interface Result {
	man_score?: number | null;
	woman_score?: number | null;
	man_risk_level?: 'LOW' | 'SLIGHTLY_ELEVATED' | 'SUBSTANTIALLY_ELEVATED' | 'HIGH' | null;
	woman_risk_level?: 'LOW' | 'SLIGHTLY_ELEVATED' | 'SUBSTANTIALLY_ELEVATED' | 'HIGH' | null;
	man_physical_overload_probability?: string | null;
	man_health_consequences?: string | null;
	man_measures?: string | null;
	woman_physical_overload_probability?: string | null;
	woman_health_consequences?: string | null;
	woman_measures?: string | null;
	comment?: string | null;
}

export enum FieldNamesEnum {
	GENERAL_INFORMATION = 'general_information',
	FREQUENCY = 'frequency',
	POSTURE = 'posture',
	WORK_CONDITION = 'work_condition',
	WORK_ORGANIZATION = 'work_organization',
	RESULT = 'result'
}

export interface FormFields {
	[FieldNamesEnum.GENERAL_INFORMATION]: GeneralInformation;
	[FieldNamesEnum.FREQUENCY]: Frequency;
	[FieldNamesEnum.POSTURE]: Posture;
	[FieldNamesEnum.WORK_CONDITION]: WorkCondition;
	[FieldNamesEnum.WORK_ORGANIZATION]: WorkOrganization;
	[FieldNamesEnum.RESULT]: Result;
}

export interface FactorOption {
	value: string;
	labelKey: string;
}

export interface FactorGroup {
	name: string;
	options: FactorOption[];
}
